module.exports = __webpack_public_path__ + "img/default_location_marker.173b94dc.svg";